import React, { useEffect } from "react";
import "./styles.css";

export const handler = ({ inputs, mechanic }) => {
  const {
    format,
    customWidth,
    customHeight,
    image
  } = inputs;

  // Calculate dimensions based on format
  const formatDimensions = {
    vertical: { width: 1080, height: 1350 },
    square: { width: 1080, height: 1080 },
    landscape: { width: 1080, height: 566 },
    story: { width: 1080, height: 1920 },
    custom: { width: customWidth, height: customHeight }
  };
  
  const { width, height } = formatDimensions[format];

  // Convert File to URL if needed
  const imageUrl = image ? (typeof image === 'string' ? image : URL.createObjectURL(image)) : null;

  useEffect(() => {
    mechanic.done();
  }, []);

  return (
    <div
      className="image-layout-container"
      style={{
        width: `${width}px`,
        height: `${height}px`,
        backgroundColor: "#ffffff",
        display: "flex",
        alignItems: "flex-end",
        boxSizing: "border-box",
        position: "relative",
        overflow: "hidden"
      }}
    >
      {imageUrl && (
        <img
          src={imageUrl}
          alt=""
          style={{
            width: "90%",
            height: "auto",
            maxHeight: "100%",
            objectFit: "contain",
            borderTop: "20px solid #fcf3c2",
            borderRight: "50px solid #fcf3c2",
            borderBottom: "30px solid #fcf3c2",
            borderLeft: "0",
            boxSizing: "border-box"
          }}
        />
      )}
    </div>
  );
};

export const inputs = {
  format: {
    type: "text",
    default: "vertical",
    options: ["vertical", "square", "landscape", "story", "custom"],
    label: "Format"
  },
  customWidth: {
    type: "number",
    default: 1080,
    label: "Width",
    editable: (inputs) => inputs.format === "custom",
    validation: () => null
  },
  customHeight: {
    type: "number",
    default: 1350,
    label: "Height",
    editable: (inputs) => inputs.format === "custom",
    validation: () => null
  },
  image: {
    type: "image"
  }
};

export const presets = {
  vertical: {
    format: "vertical"
  },
  square: {
    format: "square"
  },
  landscape: {
    format: "landscape"
  },
  story: {
    format: "story"
  }
};

export const settings = {
  engine: require("@mechanic-design/engine-react"),
  name: "Image Layout",
  hideFunction: true
};
